module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "SOM"
  }, [_c('h1', {
    staticClass: "SOM_titre"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBLISHER")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGARDING")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGITAL")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENERAL")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4"
    }
  }, [_vm._v("A G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UIDE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TO")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SING")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BBREVIATIONS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TO")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HORTER")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('a', {
    attrs: {
      "href": "#/p1dev1"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLOSSIANS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap2"
    }
  }, [_vm._v("Salutation and Thanksgiving Colossians 1:1-8")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap3"
    }
  }, [_vm._v("Intercession Through Christ Colossians 1:9-14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap4"
    }
  }, [_vm._v("The Person and Work of Christ Colossians 1:15-23")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Work Colossians 1:24-2:5")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Consider the Means of Salvation Colossians 2:6-15")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Danger of False Observance Colossians 2:16-23")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Principles of The New Life Colossians 3:1-17")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Social Duties Colossians 3:18–4:1")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Admonitions and Final Greetings Colossians 4:2-18")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p2dev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" 1 T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HESSALONIANS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greetings and Praise 1 Thessalonians 1:1-10")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Solicitous Care 1 Thessalonians 2:1-12")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Integrity of the Preacher 1 Thessalonians 2:13-20")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Travail and Consolation 1 Thessalonians 3:1-13")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exhortation to Godly Faith and Love 1 Thessalonians 4:1-12")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joy in the Face of Death 1 Thessalonians 4:13-18")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preparation for the Lord’s Coming 1 Thessalonians 5:1-11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Exhortations and Greetings 1 Thessalonians 5:12-28")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p3dev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" 2 T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HESSALONIANS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salutation and Reminder of Coming Judgment 2 Thessalonians 1:1-12")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Signs of the Coming Judgment 2 Thessalonians 2:1-12")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reassurance 2 Thessalonians 2:13-17")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Power Belongs to God 2 Thessalonians 3:1-5")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Warning Against Idleness 2 Thessalonians 3:6-12")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Exhortations 2 Thessalonians 3:13-18")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p4dev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" 1 T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMOTHY")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salutation and Call to Hold to Sound Teaching 1 Timothy 1:1-11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thankfulness for Mercy 1 Timothy 1:12-20")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Instructions on Prayer 1 Timothy 2:1-7")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praying Men and Modest Women 1 Timothy 2:8-15")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Instructions on Bishops 1 Timothy 3:1-7")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Instructions on Deacons 1 Timothy 3:8-13")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maintaining the Household 1 Timothy 3:14-16")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("False Teaching 1 Timothy 4:1-5")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Personal Discipline for Timothy 1 Timothy 4:6-16")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Treatment of Elders, Widows and Presbyters 1 Timothy 5:1-22")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fatherly Solicitude 1 Timothy 5:23-25")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Treatment of Servants 1 Timothy 6:1-2")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Call to Personal Integrity in Teaching and in Life 1 Timothy 6:2-10")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Battle of Faith 1 Timothy 6:11-16")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Keep the Trust 1 Timothy 6:17-21")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p5dev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" 2 T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMOTHY")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p5chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salutation and Opening Admonition 2 Timothy 1:1-7")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p5chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Do Not Be Ashamed of the Gospel 2 Timothy 1:8-18")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p5chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exhortation to Steadfastness 2 Timothy 2:1-13")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p5chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exhortation to Simplicity of Faith 2 Timothy 2:14-26")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p5chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Character of Heretics 2 Timothy 3:1-9")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p5chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cost of Faithfulness 2 Timothy 3:10–4:8")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p5chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Personal Instructions and Final Greetings 2 Timothy 4:9-22")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p6dev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITUS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p6chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greetings Titus 1:1-4")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p6chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Installation of Presbyters Titus 1:5-9")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p6chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Activity of Heretics Titus 1:10-16")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p6chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Instructions for Men, Women and Slaves Titus 2:1-10")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p6chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Work of Grace Titus 2:11-15")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p6chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Admonitions to Obedience Titus 3:1-8")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p6chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Admonitions, Assignments and Greetings Titus 3:8-15")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p7dev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILEMON")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p7chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greetings and Thanksgivings Philemon 1-7")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p7chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intercession for Onesimus Philemon 8-20")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p7chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion and Greetings Philemon 21-25")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPENDIX")]), _vm._v(": E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARLY")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITERS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCUMENTS")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITED")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRONOLOGICAL")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IST")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERSONS")]), _vm._v(" & W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITINGS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IOGRAPHICAL")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("KETCHES")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHORS")]), _vm._v("/W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITINGS")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBJECT")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTES")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAISE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FOR")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCIENT")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOUT")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITOR")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCIENT")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITLES")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FROM")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTER")]), _vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARSITY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/ident11#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPYRIGHT")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AGE")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0